module.exports = __webpack_public_path__ + "img/What's On.12c17ebb.png";